import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbService} from "../service/breadcrumb.service";
import {InactivityService} from "../service/inactivity.service";
import {TriagemService} from "../service/triagem.service";
import {UserService} from "../service/user.service";
import {forkJoin, interval, Observable, Subject, switchMap, takeUntil} from "rxjs";
import {ContratoTriagem} from "../models/contrato-triagem.model";
import {ThemeService} from "../service/theme.service";

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
})
export class PagesComponent implements OnInit, OnDestroy {
  private readonly _destroy$: Subject<void> = new Subject<void>();
  private readonly _timerToKnowWhoIsOnline: number = 500 * 60;
  private readonly _timerToTellIamOnline: number = 1000 * 60;

  constructor(public breadCrumb: BreadcrumbService,
              public triagemService: TriagemService,
              public userService: UserService,
              public themeService: ThemeService,
              public inactivityService: InactivityService) {
  }

  ngOnInit() {
    this.breadCrumb.next([]);
    this.inactivityService.setup();
    this.triagemService.loadContratosAndDomains();
    this.subscribeContractsLoaded();
  }

  ngOnDestroy() {
    this.triagemService.cleanCache$.next();
    this.triagemService.cleanCache$.complete();
    this.inactivityService.teardown();
    this._destroy$.next();
    this._destroy$.complete();
  }

  subscribeWhoIsLogged() {
    const contratos = this.triagemService.cacheContratos$.value;
    const reqs: Observable<any>[] = [];
    for (let contrato of contratos) {
      reqs.push(this.userService.getActiveSessionByContract(contrato?.id ?? -1))
    }
    interval(this._timerToKnowWhoIsOnline)
      .pipe(
        takeUntil(this._destroy$),
        switchMap(() => forkJoin(reqs))
      )
      .subscribe({
        next: (users) => {
          const map = new Map<ContratoTriagem, any[]>();
          let index = 0;
          for (let user of users) {
            map.set(contratos[index], user);
            index++;
          }
          this.userService.usuariosDaSessao$.next(map);
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  updateMySessionInfo() {
    const contratos = this.triagemService.cacheContratos$.value;
    const reqs: Observable<any>[] = [];
    for (let contrato of contratos) {
      reqs.push(this.userService.updateSession({
        user: this.userService.user.userName,
        email: this.userService.user.email,
        contract: contrato?.id ?? -1
      }))
    }
    interval(this._timerToTellIamOnline)
      .pipe(
        takeUntil(this._destroy$),
        switchMap(() => forkJoin(reqs)))
      .subscribe({
        next: (users) => {
          console.log(users);
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  private subscribeContractsLoaded() {
    this.triagemService.contractsAlreadyLoaded$
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe({
        next: (loaded) => {
          if (loaded) {
            this.updateMySessionInfo();
            this.subscribeWhoIsLogged();
          }
        }
      })

  }
}
